import request from './request';
// 登录鉴权验证，获取第三方链接
export function getChargeReview(data: { uid: number }): Promise<any> {
  return request<{ uid: number }, any>(
    '/v5/charge/review/year/report',
    data,
    'POST'
  );
}
